import { render } from "./AllegroJsonForm.vue?vue&type=template&id=7634afc2&scoped=true"
import script from "./AllegroJsonForm.vue?vue&type=script&lang=js"
export * from "./AllegroJsonForm.vue?vue&type=script&lang=js"

import "./AllegroJsonForm.vue?vue&type=style&index=0&id=7634afc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7634afc2"]])

export default __exports__